import React, { createContext, useContext, useMemo } from 'react';

import type { RemindersLocalState } from './toolbar';

interface RemindersContextValue {
  remindersState: RemindersLocalState;
  setRemindersState: React.Dispatch<React.SetStateAction<RemindersLocalState>>;
}

const RemindersContext = createContext<RemindersContextValue | null>(null);

export function useRemindersContext(): RemindersContextValue {
  const ctx = useContext(RemindersContext);
  if (!ctx) throw new Error('useRemindersContext must be used within RemindersProvider');
  return ctx;
}

interface RemindersProviderProps {
  children: React.ReactNode;
  remindersStateTuple: [
    RemindersLocalState,
    React.Dispatch<React.SetStateAction<RemindersLocalState>>,
  ];
}

export function RemindersProvider({ children, remindersStateTuple }: RemindersProviderProps) {
  const [remindersState, setRemindersState] = remindersStateTuple;
  const value = useMemo(
    () => ({ remindersState, setRemindersState }),
    [remindersState, setRemindersState]
  );

  return <RemindersContext.Provider value={value}>{children}</RemindersContext.Provider>;
}
